module.exports = __webpack_public_path__ + "img/syukyaku-EC-mo-001sp.8c6243b1.jpg";